import { makeStyles, mergeClasses } from "@fluentui/react-components";
import { useScrollbarClasses } from "./useScrollClasses";

const useStyles = makeStyles({
    dropdownList: {
        maxHeight: '280px',
        overflowX: 'hidden',
        overflowY: 'auto',
        paddingInlineEnd: '1rem',
    },
});

export const useDropdownClasses = () => {

    const styles = useStyles();
    const scrollStyles = useScrollbarClasses();

    return {
        classes: {
            dropdownList: mergeClasses(styles.dropdownList, scrollStyles.classes.scrollbarClasses),
        },
    };
};